import * as Constants from '../constants/journey';

const initialState = {
  activeJourneyRecord: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.SET_ACTIVE_JOURNEY:
      return {
        ...state,
        activeJourneyRecord: action.payload,
      };
    default:
      return state;
  }
};
